import { Component, Input, OnInit } from '@angular/core';
import { HeightFacet } from '@finder/features/list/components/filters/components/height-slider/heightFacet.class';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
import { HeightSliderService } from './height-slider.service';
import { CommonModule } from '@angular/common';
import { RaCheckboxComponent } from '@finder/shared/components/ra-wrappers/ra-checkbox/ra-checkbox.component';
import { FontIconComponent } from '@finder/shared/components/font-icon/font-icon.component';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'finder-height-slider',
    templateUrl: './height-slider.component.html',
    styleUrls: ['./height-slider.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        RaCheckboxComponent,
        FontIconComponent,
        FormsModule, // For the banana box input
    ]
})
export class HeightSliderComponent implements OnInit {

    @Input() title: string;
    @Input() subtitle: string;
    @Input() heightLabel: string;
    @Input() showCheckbox = false;

    min = 0;
    max: number;
    parentComponent: ModalComponent;

    constructor(
        private heightSliderService: HeightSliderService
    ) { }

    ngOnInit() {
        this.max = this.facets && this.facets.length - 1;
    }

    get facets(): HeightFacet[] {
        return this.heightSliderService.facets;
    }

    get selectedFacet(): HeightFacet {
        return this.heightSliderService.selectedFacet;
    }

    get enabled(): boolean {
        return this.heightSliderService.enabled;
    }

    get value(): number {
        return this.heightSliderService.sliderValue;
    }

    set value(val: number) {
        this.heightSliderService.sliderValue = val;
    }

    setSelectedFacet() {
        this.heightSliderService.setSelectedFacet();
    }

    onCheck(event: any) {
        this.heightSliderService.toggle(event.detail.value);
    }
}
